var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _vm.getExpandId != -1 && _vm.getExpandId != _vm.item.id
      ? _c("div", { staticClass: "overlay-staff-row" })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "event-row" },
      [
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "10%"
            }
          },
          [
            _c("div", { staticClass: "content padding-left-27px" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.firstName,
                        expression: "item.firstName"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "first name",
                      placeholder: "First Name"
                    },
                    domProps: { value: _vm.item.firstName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "firstName", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v(_vm._s(_vm.item.firstName))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "10%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.lastName,
                        expression: "item.lastName"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "last name",
                      placeholder: "Last Name"
                    },
                    domProps: { value: _vm.item.lastName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "lastName", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v(_vm._s(_vm.item.lastName))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "16%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.email,
                        expression: "item.email"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "email",
                      placeholder: "Email"
                    },
                    domProps: { value: _vm.item.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "email", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v(_vm._s(_vm.item.email))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.phoneNumber.size
                ? _vm.columnWidth.phoneNumber.size + "px"
                : "8%"
            }
          },
          [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("the-mask", {
                  staticClass: "input-staff",
                  class: {
                    "no-border": !(_vm.item.isEditing || _vm.isEditing)
                  },
                  attrs: {
                    mask: "(###) ###-####",
                    placeholder: "Phone Number",
                    disabled: !(_vm.item.isEditing || _vm.isEditing)
                  },
                  model: {
                    value: _vm.item.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.item, "phone", $$v)
                    },
                    expression: "item.phone"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("click-outside", { attrs: { handler: _vm.hideSelectRole } }, [
          _c(
            "div",
            {
              staticClass: "column select-role",
              style: {
                width: _vm.columnWidth.role.size
                  ? _vm.columnWidth.role.size + "px"
                  : "14%"
              }
            },
            [
              _c("div", { staticClass: "content" }, [
                _c("span", { class: { "placeholder-color": !_vm.item.role } }, [
                  _vm._v(_vm._s(_vm.getRolesShow()))
                ])
              ]),
              _vm._v(" "),
              _vm.isSelectRole
                ? _c(
                    "div",
                    { staticClass: "role-selector show-on-top" },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-form-checkbox-group",
                            {
                              attrs: { id: "checkboxes-role", name: "roles" },
                              model: {
                                value: _vm.selectedRoles,
                                callback: function($$v) {
                                  _vm.selectedRoles = $$v
                                },
                                expression: "selectedRoles"
                              }
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    id: _vm.item.id + "-lead",
                                    value: "lead"
                                  }
                                },
                                [_vm._v("Lead")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    id: _vm.item.id + "-screener",
                                    value: "screener"
                                  }
                                },
                                [_vm._v("Screener\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    id: _vm.item.id + "-concierge",
                                    value: "concierge"
                                  }
                                },
                                [_vm._v("Concierge\n              ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.events.size + "px"
                : "10%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(_vm._s(_vm.item.totalEvents))])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.payRates.size
                ? _vm.columnWidth.payRates.size + "px"
                : "8%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.payRates,
                        expression: "item.payRates"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "Pay Rate",
                      placeholder: "Pay Rate"
                    },
                    domProps: { value: _vm.item.payRates },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "payRates", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v("$ " + _vm._s(_vm.item.payRates || 0))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.address.size
                ? _vm.columnWidth.address.size + "px"
                : "20%"
            }
          },
          [
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm.isUsedBingMap && (_vm.item.isEditing || _vm.isEditing)
                  ? _c(
                      "div",
                      { attrs: { id: "searchBoxStaffContainer-" + _vm.index } },
                      [
                        _c("label", {
                          attrs: { for: "searchBoxStaff-" + _vm.index }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.address,
                              expression: "item.address"
                            }
                          ],
                          staticClass: "map-wrapper",
                          attrs: {
                            type: "text",
                            id: "searchBoxStaff-" + _vm.index,
                            placeholder: "Address"
                          },
                          domProps: { value: _vm.item.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.item, "address", $event.target.value)
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isUsedBingMap && (_vm.item.isEditing || _vm.isEditing)
                  ? _c("vue-google-autocomplete", {
                      attrs: {
                        name: "address-input",
                        id: "map_" + _vm.index,
                        classname: "map-wrapper",
                        placeholder: _vm.item.address || "Enter address",
                        country: ["us"],
                        item: _vm.item
                      },
                      on: { placechanged: _vm.setPlace, change: _vm.getValue }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !(_vm.item.isEditing || _vm.isEditing)
                  ? _c("span", [_vm._v(_vm._s(_vm.item.address))])
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column col-group-btn-action",
            style: {
              width: _vm.columnWidth.actions.size
                ? _vm.columnWidth.actions.size + "px"
                : "4%"
            }
          },
          [
            _c("div", { staticClass: "btn-func" }, [
              _c("div", { staticClass: "btn-func-item" }, [
                _c("div", {
                  staticClass: "func-icon icon-info",
                  on: {
                    click: function($event) {
                      _vm.openStaffDetail(_vm.item)
                    }
                  }
                })
              ])
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "displayNone",
        class: { openContent: _vm.item.id == _vm.getExpandId }
      },
      [
        _c("div", { staticClass: "dt-row-item-detail" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 text-right margin-top-10px" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "ap-btn secondary",
                    on: {
                      click: function($event) {
                        _vm.cancelSave()
                      }
                    }
                  },
                  [_vm._v("\n            cancel\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "ap-btn primary",
                    attrs: { disabled: !_vm.canSave },
                    on: {
                      click: function($event) {
                        _vm.saveStaff()
                      }
                    }
                  },
                  [_vm._v("\n            save\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07e3de95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e3de95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/staffing/StaffingRow.vue
// module id = 2092
// module chunks = 1